// Auto-generated from Tag_logic.xlsx
const tagData = {
  "Industrial & Business Supplies": {
    "Office Supplies": {
      "Stationery": { categoryTags: "ind_stationery, office_supplies", typeTag: "Product Type_Stationery" },
      "Printers": { categoryTags: "ind_printers, office_equipment", typeTag: "Product Type_Printers" },
      "Ink & Toner": { categoryTags: "ind_ink_toner, consumables, catridges", typeTag: "Product Type_Ink & Toners" }
    },
    "Safety & Security": {
      "Personal Protective Equipment (PPE)": { categoryTags: "ind_ppe, safety_gear", typeTag: "Product Type_Personal Protective Equipments(PPE)" },
      "Fire Safety Equipment": { categoryTags: "ind_fire_safety", typeTag: "Product Type_Fire Safety Equipments" },
      "Surveillance & CCTV": { categoryTags: "ind_cctv, security_systems", typeTag: "Product Type_Surveillance & CCTV" }
    },
    "Tools & Hardware": {
      "Hand Tools": { categoryTags: "ind_hand_tools", typeTag: "Product Type_Hand Tools" },
      "Power Tools": { categoryTags: "ind_power_tools", typeTag: "Product Type_Power Tools" }
    },
    "Electrical & Lighting": {
      "Electrical Components": { categoryTags: "ind_electrical_components", typeTag: "Product Type_Electrical Components" },
      "Industrial Lighting": { categoryTags: "ind_industrial_lighting", typeTag: "Product Type_Industrial Lighting" }
    },
    "Cleaning & Janitorial": {
      "Cleaning Chemicals": { categoryTags: "ind_cleaning_chemicals, hazmat_candidate", typeTag: "Product Type_Cleaning Chemicals" },
      "Cleaning Equipment": { categoryTags: "ind_cleaning_equipment", typeTag: "Product Type_Cleaning Equipments" }
    },
    "Packaging & Shipping": {
      "Boxes & Cartons": { categoryTags: "ind_boxes_cartons", typeTag: "Product Type_Boxes & Cartons" },
      "Tapes & Labels": { categoryTags: "ind_tapes_labels", typeTag: "Product Type_Tapes & Labels" }
    }
  },
  "Home & Garden": {
    "Kitchen & Dining": {
      "Cookware": { categoryTags: "home_cookware", typeTag: "Product Type_Cookware" },
      "Kitchen Utensils": { categoryTags: "home_kitchen_utensils", typeTag: "Product Type_Kitchen Utensils" },
      "Kitchen Appliances": { categoryTags: "home_kitchen_appliances", typeTag: "Product Type_Kitchen Appliances" },
      "Tableware": { categoryTags: "home_tableware", typeTag: "Product Type_Tableware" },
      "Kitchen Storage": { categoryTags: "home_kitchen_storage", typeTag: "Product Type_Kitchen Storages" }
    },
    "Furniture": {
      "Living Room Furniture": { categoryTags: "home_furniture_living", typeTag: "Product Type_Living Room Furniture" },
      "Bedroom Furniture": { categoryTags: "home_furniture_bedroom", typeTag: "Product Type_Bedroom Furniture" },
      "Mattress": { categoryTags: "home_furniture_mattress", typeTag: "Product Type_Mattresses" },
      "Office Furniture": { categoryTags: "home_furniture_office", typeTag: "Product Type_Office Furniture" }
    },
    "Home Décor": {
      "Wall Décor": { categoryTags: "home_wall_decor", typeTag: "Product Type_Wall Decor" },
      "Decorative Lighting": { categoryTags: "home_decor_lighting", typeTag: "Product Type_Decorative Lighting" },
      "Solar Lighting": { categoryTags: "home_solar_lighting", typeTag: "Product Type_Solar Lighting" }
    },
    "Bedding & Bath": {
      "Bedsheets & Blankets": { categoryTags: "home_bedding", typeTag: "Product Type_Bedsheets & Blankets" },
      "Towels & Bath Accessories": { categoryTags: "home_bath", typeTag: "Product Type_Towels & Bath Accessories" }
    },
    "Storage & Organization": {
      "Storage Boxes & Organizers": { categoryTags: "home_storage", typeTag: "Product Type_Storage Boxes & Organizers" },
      "Tissue & Napkin Holders": { categoryTags: "home_storage", typeTag: "Product Type_Tissue & Napkin Holders" }
    },
    "Garden & Outdoor": {
      "Garden Tools": { categoryTags: "home_garden_tools", typeTag: "Product Type_Garden Tools" },
      "Outdoor Furniture": { categoryTags: "home_outdoor_furniture", typeTag: "Product Type_Outdoor Furniture" },
      "Camping Supplies": { categoryTags: "home_camping_supplies", typeTag: "Product Type_Camping Supplies" }
    },
    "Home Improvement": {
      "Plumbing Supplies": { categoryTags: "home_plumbing", typeTag: "Product Type_Plumbing Supplies" },
      "Electrical Fittings": { categoryTags: "home_electrical_fittings", typeTag: "Product Type_Electrical Fittings" },
      "Paint & Hardware": { categoryTags: "home_paint_hardware", typeTag: "Product Type_Paint & Hardware" },
      "Toilet Supplies": { categoryTags: "home_toilet_supplies", typeTag: "Product Type_Toilet Supplies" }
    }
  },
  "Health & Fitness": {
    "Fitness Equipment": {
      "Cardio Equipment": { categoryTags: "health_cardio", typeTag: "Product Type_Cardio Equipments" },
      "Strength Training Equipment": { categoryTags: "health_strength", typeTag: "Product Type_Strength Training Equipments" }
    },
    "Nutrition & Supplements": {
      "Protein Supplements": { categoryTags: "health_protein, regulated_candidate", typeTag: "Product Type_Protein Supplements" },
      "Vitamins & Minerals": { categoryTags: "health_vitamins, regulated_candidate", typeTag: "Product Type_Vitamins & Minerals" }
    },
    "Medical Supplies": {
      "Blood Pressure Monitors": { categoryTags: "health_bp_monitors", typeTag: "Product Type_Blood Pressure Monitors" },
      "Thermometers": { categoryTags: "health_thermometers", typeTag: "Product Type_Thermometers" }
    },
    "Personal Health Devices": {
      "Weighing Scales": { categoryTags: "health_scales", typeTag: "Product Type_Weighing Scales" },
      "Massagers": { categoryTags: "health_massagers", typeTag: "Product Type_Massagers" }
    },
    "Wellness & Therapy": {
      "Orthopedic Supports": { categoryTags: "health_orthopedic", typeTag: "Product Type_Orthopedic Supports" },
      "Therapy Equipment": { categoryTags: "health_therapy", typeTag: "Product Type_Therapy Equipments" }
    },
    "Sports Accessories": {
      "Gloves & Supports": { categoryTags: "health_sports_supports", typeTag: "Product Type_Gloves & Supports" },
      "Fitness Tracker": { categoryTags: "health_fitness_tracker", typeTag: "Product Type_Fitness Trackers" }
    }
  },
  "Pet Supplies": {
    "Dog Supplies": {
      "Dog Food": { categoryTags: "pet_dog_food", typeTag: "Product Type_Dog Food" },
      "Dog Treats": { categoryTags: "pet_dog_treats", typeTag: "Product Type_Dog Treats" },
      "Dog Toys": { categoryTags: "pet_dog_toys", typeTag: "Product Type_Dog Toys" },
      "Dog Grooming": { categoryTags: "pet_dog_grooming", typeTag: "Product Type_Dog Grooming" }
    },
    "Cat Supplies": {
      "Cat Food": { categoryTags: "pet_cat_food", typeTag: "Product Type_Cat Food" },
      "Cat Litter": { categoryTags: "pet_cat_litter", typeTag: "Product Type_Cat Litter" },
      "Cat Toys": { categoryTags: "pet_cat_toys", typeTag: "Product Type_Cat Toys" }
    },
    "Fish & Aquatics": {
      "Aquariums": { categoryTags: "pet_aquariums", typeTag: "Product Type_Aquariums" },
      "Fish Feed": { categoryTags: "pet_fish_feed", typeTag: "Product Type_Fish Feeds" }
    },
    "Bird Supplies": {
      "Bird Cages": { categoryTags: "pet_bird_cages", typeTag: "Product Type_Bird Cages" },
      "Bird Feed": { categoryTags: "pet_bird_feed", typeTag: "Product Type_Bird Feeds" }
    },
    "Small Pets": {
      "Small Pet Food": { categoryTags: "pet_small_food", typeTag: "Product Type_Small Pet Food" }
    },
    "Pet Health": {
      "Pet Supplements": { categoryTags: "pet_supplements", typeTag: "Product Type_Pet Supplements" }
    }
  },
  "Beauty & Personal Care": {
    "Skincare": {
      "Cleansers": { categoryTags: "beauty_cleansers", typeTag: "" },
      "Moisturizers": { categoryTags: "beauty_moisturizers", typeTag: "" },
      "Serums": { categoryTags: "beauty_serums", typeTag: "" }
    },
    "Haircare": {
      "Shampoo & Conditioner": { categoryTags: "beauty_shampoo_conditioner", typeTag: "" },
      "Hair Styling Tools": { categoryTags: "beauty_hair_tools", typeTag: "Product Type_Hair Styling Tools" },
      "Wigs & Extensions": { categoryTags: "beauty_haircare", typeTag: "Product Type_Wigs" }
    },
    "Makeup": {
      "Makeup Kit & Bags": { categoryTags: "beauty_makeup", typeTag: "Product Type_Makeup" }
    },
    "Fragrances": {
      "Perfumes": { categoryTags: "beauty_perfumes", typeTag: "" }
    },
    "Personal Hygiene": {
      "Oral Care": { categoryTags: "beauty_oral_care", typeTag: "Product Type_Oral Care" },
      "Bath & Body": { categoryTags: "beauty_bath_body", typeTag: "Product Type_Bath & Body" }
    },
    "Grooming": {
      "Grooming Accessories": { categoryTags: "grooming_accessories", typeTag: "Product Type_Razors" }
    }
  },
  "Auto & Tools": {
    "Car Accessories": {
      "Seat & Lumbar Support": { categoryTags: "auto_seat_covers", typeTag: "Product Type_Car Seat Covers" },
      "Car Chargers": { categoryTags: "auto_chargers", typeTag: "Product Type_Car Charger" },
      "Car Stereo with GPS": { categoryTags: "auto_car_stereo", typeTag: "Product Type_Auto Accessories" }
    },
    "Bike Accessories": {
      "Seat Covers": { categoryTags: "auto_seat_covers", typeTag: "Product Type_Bike Seat Covers" },
      "Bike Helmets": { categoryTags: "auto_helmets", typeTag: "Product Type_Bike Helmets" }
    },
    "Automotive Parts": {
      "Engine Oils": { categoryTags: "auto_engine_oil, hazmat_candidate", typeTag: "" },
      "Filters": { categoryTags: "auto_filters", typeTag: "Product Type_Auto Filter" }
    },
    "Tools": {
      "Hand & Power Tools": { categoryTags: "auto_hand_power_tools", typeTag: "" },
      "Diagnostics": { categoryTags: "auto_diagnostics", typeTag: "" }
    },
    "Garage Equipment": {
      "Car Jacks": { categoryTags: "auto_car_jacks", typeTag: "" }
    },
    "Safety Gear": {
      "Safety Gloves": { categoryTags: "auto_safety_gloves", typeTag: "" }
    }
  },
  "Toys & Kids": {
    "Toys & Games": {
      "Action Toys": { categoryTags: "kids_action_toys", typeTag: "" },
      "Board Games": { categoryTags: "kids_board_games", typeTag: "Product Type_Board Games" }
    },
    "Baby Care": {
      "Diapers": { categoryTags: "kids_diapers", typeTag: "" },
      "Baby Feeding": { categoryTags: "kids_feeding", typeTag: "" }
    },
    "Kids Clothing": {
      "Boys Clothing": { categoryTags: "kids_boys_clothing", typeTag: "Product Type_Boy's Clothing" },
      "Girls Clothing": { categoryTags: "kids_girls_clothing", typeTag: "Product Type_Girl's Clothing" }
    },
    "Learning & Education": {
      "STEM Toys": { categoryTags: "kids_stem", typeTag: "Product Type_Stem Toys" }
    },
    "School Supplies": {
      "School Bags": { categoryTags: "kids_school_bags", typeTag: "Product Type_School Bags" },
      "Learning Tools": { categoryTags: "kids_learning_tools", typeTag: "Product Type_Learning Tools" }
    },
    "Outdoor Play": {
      "Ride-Ons": { categoryTags: "kids_ride_ons", typeTag: "" }
    },
    "Baby Gear": {
      "Strollers": { categoryTags: "kids_strollers", typeTag: "" }
    }
  },
  "Apparel & Fashion": {
    "Men's Clothing": {
      "Shirts": { categoryTags: "fashion_mens_shirts", typeTag: "" },
      "Trousers": { categoryTags: "fashion_mens_trousers", typeTag: "" }
    },
    "Women's Clothing": {
      "Dresses": { categoryTags: "fashion_womens_dresses", typeTag: "Product Type_Women's Dresses" },
      "Tops": { categoryTags: "fashion_womens_tops", typeTag: "Product Type_Women's Tops" },
      "Womens Sweaters&Cardigans": { categoryTags: "women", typeTag: "Product Type_Womens Sweaters&Cardigans"}
    },
    "Baby & Kidswear": {
      "Kids Apparel": { categoryTags: "fashion_kids", typeTag: "Product Type_Childrens Apparel" }
    },
    "Footwear": {
      "Casual Shoes": { categoryTags: "fashion_casual_shoes", typeTag: "" },
      "Sports Shoes": { categoryTags: "fashion_sports_shoes", typeTag: "" }
    },
    "Accessories": {
      "Men's Necklaces": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Men's Necklaces" },
      "Women's Necklaces": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Women's Necklaces" },
      "Unisex Necklaces": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Unisex Necklaces" },
      "Men's Bracelets": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Men's Bracelets" },
      "Women's Bracelets": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Women's Bracelets" },
      "Unisex Bracelets": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Unisex Bracelets" },
      "Men's Belts": { categoryTags: "fashion_belts_wallets", typeTag: "Product Type_Men's Belts" },
      "Women's Belts": { categoryTags: "fashion_belts_wallets", typeTag: "Product Type_Women's Belts" },
      "Unisex Belts": { categoryTags: "fashion_belts_wallets", typeTag: "Product Type_Unisex Belts" },
      "Men's Wallets": { categoryTags: "fashion_belts_wallets", typeTag: "Product Type_Men's Wallets" },
      "Women's Wallets": { categoryTags: "fashion_belts_wallets", typeTag: "Product Type_Women's Wallets" },
      "Unisex Wallets": { categoryTags: "fashion_belts_wallets", typeTag: "Product Type_Unisex Wallet" },
      "Bags & Accessories": { categoryTags: "fashion_bags", typeTag: "Product Type_Bags" },
      "Men's Watches": { categoryTags: "fashion_accessories", typeTag: "Product Type_Men's Watches" },
      "Women's Watches": { categoryTags: "fashion_accessories", typeTag: "Product Type_Women's Watches" },
      "Unisex Watches": { categoryTags: "fashion_accessories", typeTag: "Product Type_Unisex Watches" },
      "Smart Watches": { categoryTags: "fashion_accessories", typeTag: "Product Type_Smart Watches" },
      "Men's Sunglasses": { categoryTags: "fashion_accessories", typeTag: "Product Type_Men's Sunglasses" },
      "Women's Sunglasses": { categoryTags: "fashion_accessories", typeTag: "Product Type_Women's Sunglasses" },
      "Unisex Sunglasses": { categoryTags: "fashion_accessories", typeTag: "Product Type_Unisex Sunglasses" },
      "Ties & Formal Accessories": { categoryTags: "fashion_accessories", typeTag: "Product Type_Ties & Formal Accessories" },
      "Men's Chains": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Men's Chains" },
      "Women's Chains": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Women's Chains" },
      "Unisex Chains": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Unisex Chains" },
      "Men's Pendants": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Men's Pendants" },
      "Women's Pendants": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Women's Pendants" },
      "Unisex Pendants": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Unisex Pendants" },
      "Men's Bangles": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Men's Bangles" },
      "Women's Bangles": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Women's Bangles" },
      "Unisex Bangles": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Unisex Bangles" },
      "Men's Rings": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Men's Rings" },
      "Women's Rings": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Women's Rings" },
      "Unisex Rings": { categoryTags: "fashion_jewelry", typeTag: "Product Type_Unisex Rings" }
    }
  },
  "Consumer Electronics": {
    "Televisions": {
      "Smart TVs": { categoryTags: "electronics_smart_tv", typeTag: "Product Type_Smart TVs" },
      "LED / OLED / QLED TVs": { categoryTags: "electronics_tv_display", typeTag: "Product Type_LED / OLED / QLED TVs" }
    },
    "Audio": {
      "Earphones / Headphones": { categoryTags: "electronics_headphones", typeTag: "Product Type_Headphones" },
      "Soundbars": { categoryTags: "electronics_soundbars", typeTag: "Product Type_Soundbar" },
      "Speakers": { categoryTags: "electronics_speakers", typeTag: "Product Type_Speakers" }
    },
    "Computers": {
      "Laptops": { categoryTags: "electronics_laptops", typeTag: "Product Type_Laptops" },
      "Desktops": { categoryTags: "electronics_desktops", typeTag: "Product Type_Desktops" },
      "Portable Monitors": { categoryTags: "electronics_monitors", typeTag: "Product Type_Portable Monitors" },
      "Computer Accessories": { categoryTags: "electronics_computer_accessories", typeTag: "Product Type_Computer Accessories" }
    },
    "Mobiles": {
      "Smartphones": { categoryTags: "electronics_smartphones", typeTag: "" },
      "Feature Phones": { categoryTags: "electronics_featurephones", typeTag: "Product Type_Feature Phones" },
      "Mobile Accessories": { categoryTags: "electronics_mobile_accessories", typeTag: "Product Type_Mobile Accessories" }
    },
    "Cameras": {
      "DSLR Cameras": { categoryTags: "electronics_dslr", typeTag: "Product Type_DSLR Cameras" },
      "Action Cameras": { categoryTags: "electronics_action_cameras", typeTag: "Product Type_Action Cameras" },
      "Camera Accessories": { categoryTags: "electronics_camera_accessories", typeTag: "Product Type_Camera Accessories" }
    },
    "Wearables": {
      "Smartwatches": { categoryTags: "electronics_smartwatches", typeTag: "Product Type_Smartwatches" }
    },
    "Smart Home": {
      "Smart Lights": { categoryTags: "electronics_smart_lights", typeTag: "Product Type_Smart Lights" },
      "Smart Cameras": { categoryTags: "electronics_smart_cameras", typeTag: "Product Type_Smart Cameras" }
    },
    "Home Appliances": {
      "Refrigerators": { categoryTags: "electronics_refrigerators", typeTag: "Product Type_Refrigerators" },
      "Air Fryers": { categoryTags: "electronics_air_fryers", typeTag: "" },
      "Washing Machines": { categoryTags: "electronics_washing_machines", typeTag: "Product Type_Washing Machines" },
      "Microwaves": { categoryTags: "electronics_microwaves", typeTag: "" },
      "Dishwashers": { categoryTags: "electronics_dishwashers", typeTag: "Product Type_Dishwashers" },
      "Air Heaters": { categoryTags: "electronics_air_heater", typeTag: "Product Type_Air Heaters" },
      "Home Appliances Accessories": { categoryTags: "electronics_home_appliances_accessories", typeTag: "Product Type_Home Appliances Accessories" }
    }
  }
};

export default tagData;
